
export const BaseUrl = 'https://partner.api.herofincorp.com/api/v1/bridge-app/leadgen' // Prod